@if (section() === 'totals') {
  <div class="mb-6">
    @if (isTicketFeeEnabled()) {
      @for (serviceCharge of serviceChargesDetails; track $index) {
        @if (serviceCharge.amount) {
          <div class="mb-4 w-full">
            <div
              class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
              <p>{{ serviceCharge.name }}</p>
              <p class="font-bold text-main">
                ${{ serviceCharge.amount | number: '1.2-2' }}
              </p>
            </div>
          </div>
        }
      }
    } @else {
      @if (transaction.transaction.tdcTransaction?.serviceCharges) {
        <div class="mb-4 w-full">
          <div
            class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
            <p>Total ticket fees</p>
            <p class="font-bold text-main">
              ${{
                transaction.transaction.tdcTransaction?.serviceCharges
                  | number: '1.2-2'
              }}
            </p>
          </div>
        </div>
      }
    }

    @if (transaction.transaction.tdcTransaction?.hasInsuranceRainout) {
      <div class="mb-4 w-full">
        <div
          class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
          <p>Rainout insurance</p>
          <p class="font-bold text-main">
            ${{
              transaction.transaction.tdcTransaction?.insuranceRainoutPrice
                | number: '1.2-2'
            }}
          </p>
        </div>
      </div>
    }
  </div>
}

@if (section() === 'legal') {
  <div class="mb-4 md:mb-2">
    <div class="flex items-start gap-2 mb-1">
      <input
        type="checkbox"
        class="mt-0.5 terms-radio"
        placeholder=""
        id="marketing"
        name="marketing"
        [value]="true"
        [(ngModel)]="paymentDetails.acceptedTerms" />
      <div>
        <label for="marketing" class="font-bold text-black text-sm"
          >I agree to the following
          <span class="text-red align-middle" aria-hidden="true">*</span></label
        >
        <app-legal-terms
          [legalTextData]="this.configurationService.configuration.legalText" />
      </div>
    </div>
    @if (
      configurationService.configuration.extraCheckbox &&
      configurationService.configuration.extraCheckbox.active
    ) {
      <div class="mt-2 mb-4 md:mb-2">
        <div class="flex items-start gap-2 mb-1">
          <input
            type="checkbox"
            class="mt-0.5 terms-radio"
            placeholder=""
            id="extra-checkbox"
            name="extra-checkbox"
            [value]="true"
            [(ngModel)]="paymentDetails.extraCheckbox" />
          <div>
            <label for="extra-checkbox" class="font-bold text-black text-sm"
              >I agree to the following
              @if (configurationService.configuration.extraCheckbox.required) {
                <span class="text-red align-middle" aria-hidden="true">*</span>
              }
            </label>
            <div
              class="font-medium text-[#7b7b7b] text-xs leading-4"
              [innerHTML]="
                configurationService.configuration.extraCheckbox.text
              "></div>
          </div>
        </div>
      </div>
    }
  </div>
}
